import { render, staticRenderFns } from "./BlogBreadcrumb.vue?vue&type=template&id=f324b676&scoped=true&"
import script from "./BlogBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./BlogBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./BlogBreadcrumb.vue?vue&type=style&index=0&id=f324b676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f324b676",
  null
  
)

export default component.exports